import useScreenSize from '../../hooks/useScreenSize'
import { useBlurActiveElementOnOpenChange } from 'utils/mui-utils'
import * as S from './Popup.styles'

export default function Popup({
  children,
  maxHeight = '',
  onClose = () => {},
  open = true,
  fullHeight = false,
  noBorderRadius = false,
  dialogStyles = {},
  slotProps = {},
  ariaLabelledBy = '',
  onExited = () => {},
}) {
  const isMediumScreen = useScreenSize('md')
  useBlurActiveElementOnOpenChange(open)
  return isMediumScreen ? (
    <S.Dialog
      sx={{ ...dialogStyles }}
      open={open}
      onClose={onClose}
      maxWidth="md"
      slotProps={slotProps}
      aria-labelledby={ariaLabelledBy || undefined}
      TransitionProps={{ onExited }}
    >
      {children}
    </S.Dialog>
  ) : (
    <S.Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      $maxHeight={maxHeight}
      $fullHeight={fullHeight}
      $noBorderRadius={noBorderRadius}
      slotProps={slotProps}
      SlideProps={{ onExited }}
    >
      {children}
    </S.Drawer>
  )
}
